const numberFormats = {
  'es-MX': {
    currency: {
      style: 'currency', currency: 'MXN', notation: 'standard'
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  },
  'en-US': {
    currency: {
      style: 'currency', currency: 'MXN', notation: 'standard'
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  }
};

export default numberFormats;